module.exports = { "default": require("core-js/library/fn/object/values"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/values.js
// module id = 732
// module chunks = 0